import { render, staticRenderFns } from "./TemplateKlassenliste.vue?vue&type=template&id=4484f341"
import script from "./TemplateKlassenliste.vue?vue&type=script&lang=js"
export * from "./TemplateKlassenliste.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports